import React from 'react'
import { CustomTypeCategory } from '../../services/CustomTypes'
import { altGreen, darkBlue, darkGray, darkGreen, lighterBlue, primaryBlue } from '../../styles/material-ui-theme-v2'

import { ReactComponent as StepsActiveIcon } from '../../assets/activity-types/steps-active.svg'
import { ReactComponent as StepsInactiveIcon } from '../../assets/activity-types/steps-inactive.svg'
import { ReactComponent as ActivityIndexActiveIcon } from '../../assets/activity-types/activity-index-active.svg'
import { ReactComponent as ActivityIndexBoldActiveIcon } from '../../assets/activity-types/activity-index-bold-active.svg'
import { ReactComponent as ActivityIndexInactiveIcon } from '../../assets/activity-types/activity-index-inactive.svg'
import { ReactComponent as WaterDrinkingActiveIcon } from '../../assets/activity-types/water-drinking-active.svg'
import { ReactComponent as WaterDrinkingInactiveIcon } from '../../assets/activity-types/water-drinking-inactive.svg'
import { ReactComponent as MinutesActiveIcon } from '../../assets/activity-types/minutes-active.svg'
import { ReactComponent as MinutesInactiveIcon } from '../../assets/activity-types/minutes-inactive.svg'
import { ReactComponent as CyclingActiveIcon } from '../../assets/activity-types/cycling-active.svg'
import { ReactComponent as CyclingInactiveIcon } from '../../assets/activity-types/cycling-inactive.svg'
import { ReactComponent as CaloriesActiveIcon } from '../../assets/activity-types/calories-active.svg'
import { ReactComponent as CaloriesInactiveIcon } from '../../assets/activity-types/calories-inactive.svg'
import { ReactComponent as SleepActiveIcon } from '../../assets/activity-types/sleep-active.svg'
import { ReactComponent as SleepInactiveIcon } from '../../assets/activity-types/sleep-inactive.svg'
import { ReactComponent as ExerciseActiveIcon } from '../../assets/activity-types/exercise-active.svg'
import { ReactComponent as ExerciseInactiveIcon } from '../../assets/activity-types/exercise-inactive.svg'
import { ReactComponent as OutdoorActiveIcon } from '../../assets/activity-types/outdoor-active.svg'
import { ReactComponent as OutdoorInactiveIcon } from '../../assets/activity-types/outdoor-inactive.svg'
import { ReactComponent as MindfulnessActiveIcon } from '../../assets/activity-types/mindfulness-active.svg'
import { ReactComponent as MindfulnessInactiveIcon } from '../../assets/activity-types/mindfulness-inactive.svg'
import { ReactComponent as PlankingActiveIcon } from '../../assets/activity-types/planking-active.svg'
import { ReactComponent as PlankingBoldActiveIcon } from '../../assets/activity-types/planking-bold-active.svg'
import { ReactComponent as PlankingInactiveIcon } from '../../assets/activity-types/planking-inactive.svg'
import { ReactComponent as RunningActiveIcon } from '../../assets/activity-types/running-active.svg'
import { ReactComponent as RunningInactiveIcon } from '../../assets/activity-types/running-inactive.svg'
import { ReactComponent as DistanceActiveIcon } from '../../assets/activity-types/distance-active.svg'
import { ReactComponent as DistanceInactiveIcon } from '../../assets/activity-types/distance-inactive.svg'
import { ReactComponent as WalkingActiveIcon } from '../../assets/activity-types/walking-active.svg'
import { ReactComponent as WalkingInactiveIcon } from '../../assets/activity-types/walking-inactive.svg'
import { ReactComponent as SwimmingActiveIcon } from '../../assets/activity-types/swimming-active.svg'
import { ReactComponent as SwimmingInactiveIcon } from '../../assets/activity-types/swimming-inactive.svg'
import { ReactComponent as YogaActiveIcon } from '../../assets/activity-types/yoga-active.svg'
import { ReactComponent as YogaInactiveIcon } from '../../assets/activity-types/yoga-inactive.svg'
import { ReactComponent as StrengthTrainingActiveIcon } from '../../assets/activity-types/strength-training-active.svg'
import { ReactComponent as StrengthTrainingInactiveIcon } from '../../assets/activity-types/strength-training-inactive.svg'
import { ReactComponent as CustomActiveIcon } from '../../assets/activity-types/custom-active.svg'
import { ReactComponent as CustomInactiveIcon } from '../../assets/activity-types/custom-inactive.svg'
import { ReactComponent as PointsActiveIcon } from '../../assets/activity-types/points-active.svg'
import { ReactComponent as PointsInactiveIcon } from '../../assets/activity-types/points-inactive.svg'
import { ReactComponent as TotalPointsActiveIcon } from '../../assets/activity-types/total-points-active.svg'
import { ReactComponent as TotalPointsInactiveIcon } from '../../assets/activity-types/total-points-inactive.svg'

import { ReactComponent as AlcoholAbstinenceActiveIcon } from '../../assets/activity-types/alcohol-abstinence-active.svg'
import { ReactComponent as AlcoholAbstinenceInactiveIcon } from '../../assets/activity-types/alcohol-abstinence-inactive.svg'
import { ReactComponent as BookReadingActiveIcon } from '../../assets/activity-types/book-reading-active.svg'
import { ReactComponent as BookReadingInactiveIcon } from '../../assets/activity-types/book-reading-inactive.svg'
import { ReactComponent as CaffeineReductionActiveIcon } from '../../assets/activity-types/caffeine-reduction-active.svg'
import { ReactComponent as CaffeineReductionInactiveIcon } from '../../assets/activity-types/caffeine-reduction-inactive.svg'
import { ReactComponent as CarFreeDaysActiveIcon } from '../../assets/activity-types/car-free-days-active.svg'
import { ReactComponent as CarFreeDaysInactiveIcon } from '../../assets/activity-types/car-free-days-inactive.svg'
import { ReactComponent as ColdPlungeActiveIcon } from '../../assets/activity-types/cold-plunge-active.svg'
import { ReactComponent as ColdPlungeInactiveIcon } from '../../assets/activity-types/cold-plunge-inactive.svg'
import { ReactComponent as ContrastShowerActiveIcon } from '../../assets/activity-types/contrast-shower-active.svg'
import { ReactComponent as ContrastShowerInactiveIcon } from '../../assets/activity-types/contrast-shower-inactive.svg'
import { ReactComponent as CreativeArtsActiveIcon } from '../../assets/activity-types/creative-arts-active.svg'
import { ReactComponent as CreativeArtsInactiveIcon } from '../../assets/activity-types/creative-arts-inactive.svg'
import { ReactComponent as DailyFlossingActiveIcon } from '../../assets/activity-types/daily-flossing-active.svg'
import { ReactComponent as DailyFlossingInactiveIcon } from '../../assets/activity-types/daily-flossing-inactive.svg'
import { ReactComponent as DailyJournalingActiveIcon } from '../../assets/activity-types/daily-journaling-active.svg'
import { ReactComponent as DailyJournalingInactiveIcon } from '../../assets/activity-types/daily-journaling-inactive.svg'
import { ReactComponent as DeepBreathingActiveIcon } from '../../assets/activity-types/deep-breathing-active.svg'
import { ReactComponent as DeepBreathingInactiveIcon } from '../../assets/activity-types/deep-breathing-inactive.svg'
import { ReactComponent as EncouragingSomeoneActiveIcon } from '../../assets/activity-types/encouraging-someone-active.svg'
import { ReactComponent as EncouragingSomeoneInactiveIcon } from '../../assets/activity-types/encouraging-someone-inactive.svg'
import { ReactComponent as FinanceTrackingActiveIcon } from '../../assets/activity-types/finance-tracking-active.svg'
import { ReactComponent as FinanceTrackingInactiveIcon } from '../../assets/activity-types/finance-tracking-inactive.svg'
import { ReactComponent as GratitudeJournalingActiveIcon } from '../../assets/activity-types/gratitude-journaling-active.svg'
import { ReactComponent as GratitudeJournalingInactiveIcon } from '../../assets/activity-types/gratitude-journaling-inactive.svg'
import { ReactComponent as HealthyCookingActiveIcon } from '../../assets/activity-types/healthy-cooking-active.svg'
import { ReactComponent as HealthyCookingInactiveIcon } from '../../assets/activity-types/healthy-cooking-inactive.svg'
import { ReactComponent as HobbyDevelopmentActiveIcon } from '../../assets/activity-types/hobby-development-active.svg'
import { ReactComponent as HobbyDevelopmentInactiveIcon } from '../../assets/activity-types/hobby-development-inactive.svg'
import { ReactComponent as IntermittentFastingActiveIcon } from '../../assets/activity-types/intermittent-fasting-active.svg'
import { ReactComponent as IntermittentFastingInactiveIcon } from '../../assets/activity-types/intermittent-fasting-inactive.svg'
import { ReactComponent as LanguageAcquisitionActiveIcon } from '../../assets/activity-types/language-acquisition-active.svg'
import { ReactComponent as LanguageAcquisitionInactiveIcon } from '../../assets/activity-types/language-acquisition-inactive.svg'
import { ReactComponent as MoodTrackingActiveIcon } from '../../assets/activity-types/mood-tracking-active.svg'
import { ReactComponent as MoodTrackingInactiveIcon } from '../../assets/activity-types/mood-tracking-inactive.svg'
import { ReactComponent as NaturalLightExposureActiveIcon } from '../../assets/activity-types/natural-light-exposure-active.svg'
import { ReactComponent as NaturalLightExposureInactiveIcon } from '../../assets/activity-types/natural-light-exposure-inactive.svg'
import { ReactComponent as PhoneFreeTimeActiveIcon } from '../../assets/activity-types/phone-free-time-active.svg'
import { ReactComponent as PhoneFreeTimeInactiveIcon } from '../../assets/activity-types/phone-free-time-inactive.svg'
import { ReactComponent as PullUpsActiveIcon } from '../../assets/activity-types/pull-ups-active.svg'
import { ReactComponent as PullUpsInactiveIcon } from '../../assets/activity-types/pull-ups-inactive.svg'
import { ReactComponent as PushUpsActiveIcon } from '../../assets/activity-types/push-ups-active.svg'
import { ReactComponent as PushUpsInactiveIcon } from '../../assets/activity-types/push-ups-inactive.svg'
import { ReactComponent as ScreenFreeMealsActiveIcon } from '../../assets/activity-types/screen-free-meals-active.svg'
import { ReactComponent as ScreenFreeMealsInactiveIcon } from '../../assets/activity-types/screen-free-meals-inactive.svg'
import { ReactComponent as SmokingCessationActiveIcon } from '../../assets/activity-types/smoking-cessation-active.svg'
import { ReactComponent as SmokingCessationInactiveIcon } from '../../assets/activity-types/smoking-cessation-inactive.svg'
import { ReactComponent as SocializingWithFriendsActiveIcon } from '../../assets/activity-types/socializing-with-friends-active.svg'
import { ReactComponent as SocializingWithFriendsInactiveIcon } from '../../assets/activity-types/socializing-with-friends-inactive.svg'
import { ReactComponent as SquattingActiveIcon } from '../../assets/activity-types/squatting-active.svg'
import { ReactComponent as SquattingInactiveIcon } from '../../assets/activity-types/squatting-inactive.svg'
import { ReactComponent as StressLevelMonitoringActiveIcon } from '../../assets/activity-types/stress-level-monitoring-active.svg'
import { ReactComponent as StressLevelMonitoringInactiveIcon } from '../../assets/activity-types/stress-level-monitoring-inactive.svg'

import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
  withBg: {
    width: '32px',
    height: '32px',
    padding: '8px',
    borderRadius: '6px',
  },
  extraPadding: {
    width: '28px',
    height: '32px',
    padding: '4px 0 4px 4px',
  },
  withGrayBg: {
    background: 'rgba(7, 19, 63, 0.05)',
  },
  withWhiteBg: {
    background: '#fff',
  },
  withLightBlueBg: {
    background: lighterBlue,
  },
  withGreenColor: {
    color: altGreen,
  },
  withDarkBlueColor: {
    color: darkBlue,
  },
  withDarkGreenColor: {
    color: darkGreen,
  },
  withDarkGrayColor: {
    color: darkGray,
  },
  withNormalColor: {
    color: primaryBlue,
  },
}))

const getIcon = (category: CustomTypeCategory, isInactive?: boolean, preferBold?: boolean) => {
  switch (category) {
    // Legacy.
    case CustomTypeCategory.ALL:
      return !isInactive
        ? preferBold
          ? ActivityIndexBoldActiveIcon
          : ActivityIndexActiveIcon
        : ActivityIndexInactiveIcon
    case CustomTypeCategory.STEPS:
      return !isInactive ? StepsActiveIcon : StepsInactiveIcon
    case CustomTypeCategory.CALORIES:
      return !isInactive ? CaloriesActiveIcon : CaloriesInactiveIcon
    case CustomTypeCategory.INTENSIVE_MINUTES:
      return !isInactive ? MinutesActiveIcon : MinutesInactiveIcon
    // Newer.
    case CustomTypeCategory.CYCLING:
      return !isInactive ? CyclingActiveIcon : CyclingInactiveIcon
    case CustomTypeCategory.DISTANCE:
      return !isInactive ? DistanceActiveIcon : DistanceInactiveIcon
    case CustomTypeCategory.EXERCISE:
    case CustomTypeCategory.OTHER_MIN:
      return !isInactive ? ExerciseActiveIcon : ExerciseInactiveIcon
    case CustomTypeCategory.MINDFULNESS:
      return !isInactive ? MindfulnessActiveIcon : MindfulnessInactiveIcon
    case CustomTypeCategory.OUTDOOR_TIME:
      return !isInactive ? OutdoorActiveIcon : OutdoorInactiveIcon
    case CustomTypeCategory.PLANKING:
      return !isInactive ? (preferBold ? PlankingBoldActiveIcon : PlankingActiveIcon) : PlankingInactiveIcon
    case CustomTypeCategory.RUNNING:
      return !isInactive ? RunningActiveIcon : RunningInactiveIcon
    case CustomTypeCategory.SLEEP:
      return !isInactive ? SleepActiveIcon : SleepInactiveIcon
    case CustomTypeCategory.SWIMMING:
      return !isInactive ? SwimmingActiveIcon : SwimmingInactiveIcon
    case CustomTypeCategory.WALKING:
      return !isInactive ? WalkingActiveIcon : WalkingInactiveIcon
    case CustomTypeCategory.WATER_DRINKING:
      return !isInactive ? WaterDrinkingActiveIcon : WaterDrinkingInactiveIcon
    case CustomTypeCategory.YOGA:
      return !isInactive ? YogaActiveIcon : YogaInactiveIcon
    case CustomTypeCategory.STRENGTH_TRAINING:
      return !isInactive ? StrengthTrainingActiveIcon : StrengthTrainingInactiveIcon
    case CustomTypeCategory.POINTS:
      return !isInactive ? PointsActiveIcon : PointsInactiveIcon
    case CustomTypeCategory.TOTAL_POINTS:
      return !isInactive ? TotalPointsActiveIcon : TotalPointsInactiveIcon
    // New manual entry types.
    case CustomTypeCategory.ALCOHOL_ABSTINENCE:
      return !isInactive ? AlcoholAbstinenceActiveIcon : AlcoholAbstinenceInactiveIcon
    case CustomTypeCategory.BOOK_READING:
      return !isInactive ? BookReadingActiveIcon : BookReadingInactiveIcon
    /*case CustomTypeCategory.CAFFEINE_REDUCTION:
      return !isInactive ? CaffeineReductionActiveIcon : CaffeineReductionInactiveIcon*/
    case CustomTypeCategory.CAR_FREE_DAYS:
      return !isInactive ? CarFreeDaysActiveIcon : CarFreeDaysInactiveIcon
    case CustomTypeCategory.COLD_PLUNGE:
      return !isInactive ? ColdPlungeActiveIcon : ColdPlungeInactiveIcon
    case CustomTypeCategory.CONTRAST_SHOWER:
      return !isInactive ? ContrastShowerActiveIcon : ContrastShowerInactiveIcon
    case CustomTypeCategory.CREATIVE_ARTS:
      return !isInactive ? CreativeArtsActiveIcon : CreativeArtsInactiveIcon
    case CustomTypeCategory.DAILY_FLOSSING:
      return !isInactive ? DailyFlossingActiveIcon : DailyFlossingInactiveIcon
    case CustomTypeCategory.DAILY_JOURNALING:
      return !isInactive ? DailyJournalingActiveIcon : DailyJournalingInactiveIcon
    case CustomTypeCategory.DEEP_BREATHING:
      return !isInactive ? DeepBreathingActiveIcon : DeepBreathingInactiveIcon
    case CustomTypeCategory.ENCOURAGING:
      return !isInactive ? EncouragingSomeoneActiveIcon : EncouragingSomeoneInactiveIcon
    case CustomTypeCategory.FINANCE_TRACKING:
      return !isInactive ? FinanceTrackingActiveIcon : FinanceTrackingInactiveIcon
    case CustomTypeCategory.GRATITUDE_JOURNALING:
      return !isInactive ? GratitudeJournalingActiveIcon : GratitudeJournalingInactiveIcon
    case CustomTypeCategory.HEALTHY_COOKING:
      return !isInactive ? HealthyCookingActiveIcon : HealthyCookingInactiveIcon
    case CustomTypeCategory.HOBBY_DEVELOPMENT:
      return !isInactive ? HobbyDevelopmentActiveIcon : HobbyDevelopmentInactiveIcon
    case CustomTypeCategory.INTERMITTENT_FASTING:
      return !isInactive ? IntermittentFastingActiveIcon : IntermittentFastingInactiveIcon
    case CustomTypeCategory.LANGUAGE_LEARNING:
      return !isInactive ? LanguageAcquisitionActiveIcon : LanguageAcquisitionInactiveIcon
    /*case CustomTypeCategory.MOOD_TRACKING:
      return !isInactive ? MoodTrackingActiveIcon : MoodTrackingInactiveIcon*/
    case CustomTypeCategory.NATURAL_LIGHT_EXPOSURE:
      return !isInactive ? NaturalLightExposureActiveIcon : NaturalLightExposureInactiveIcon
    case CustomTypeCategory.PHONE_FREE_TIME:
      return !isInactive ? PhoneFreeTimeActiveIcon : PhoneFreeTimeInactiveIcon
    case CustomTypeCategory.PULL_UPS:
      return !isInactive ? PullUpsActiveIcon : PullUpsInactiveIcon
    case CustomTypeCategory.PUSH_UPS:
      return !isInactive ? PushUpsActiveIcon : PushUpsInactiveIcon
    case CustomTypeCategory.SCREEN_FREE_MEALS:
      return !isInactive ? ScreenFreeMealsActiveIcon : ScreenFreeMealsInactiveIcon
    case CustomTypeCategory.SMOKING_CESSATION:
      return !isInactive ? SmokingCessationActiveIcon : SmokingCessationInactiveIcon
    case CustomTypeCategory.SOCIALIZING_WITH_FRIENDS:
      return !isInactive ? SocializingWithFriendsActiveIcon : SocializingWithFriendsInactiveIcon
    case CustomTypeCategory.SQUATTING:
      return !isInactive ? SquattingActiveIcon : SquattingInactiveIcon
    /*case CustomTypeCategory.STRESS_LEVEL_MONITORING:
      return !isInactive ? StressLevelMonitoringActiveIcon : StressLevelMonitoringInactiveIcon*/
    case CustomTypeCategory.BONUS_SIMPLE:
    case CustomTypeCategory.BONUS_WITH_AMOUNT:
      return !isInactive ? PointsActiveIcon : PointsInactiveIcon
    default:
      return !isInactive ? CustomActiveIcon : CustomInactiveIcon
  }
}

export interface IYumActivityIconProps {
  category: CustomTypeCategory
  color?: 'green' | 'darkBlue' | 'darkGray' | 'darkGreen'
  bg?: 'gray' | 'white' | 'lightBlue'
  isInactive?: boolean
  extraPadding?: boolean
}

const getClassNames = (classes: any, color?: string, bg?: string, extraPadding?: boolean) => {
  const className = []

  if (bg === 'gray') {
    className.push(classes.withBg, classes.withGrayBg)
  } else if (bg === 'white') {
    className.push(classes.withBg, classes.withWhiteBg)
  } else if (bg === 'lightBlue') {
    className.push(classes.withBg, classes.withLightBlueBg)
  }

  if (extraPadding) {
    className.push(classes.extraPadding)
  }

  if (color === 'green') {
    className.push(classes.withGreenColor)
  } else if (color === 'darkBlue') {
    className.push(classes.withDarkBlueColor)
  } else if (color === 'darkGreen') {
    className.push(classes.withDarkGreenColor)
  } else if (color === 'darkGray') {
    className.push(classes.withDarkGrayColor)
  } else {
    className.push(classes.withNormalColor)
  }

  return className.join(' ')
}

export const YumActivityIcon = (props: IYumActivityIconProps) => {
  const classes = useStyles()
  const { category, color, bg, isInactive, extraPadding } = props

  const Icon = getIcon(category, isInactive, !!bg)
  return <Icon className={getClassNames(classes, color, bg, extraPadding)} />
}
